module.exports = __webpack_public_path__ + "static/img/sj2.8a5c998e.png";